import { create } from "zustand";

interface StatisticsTariffState {
  // null — все тарифы, иначе список выбранных
  selectedTariffs: string[] | null;
  setSelectedTariffs: (tariffs: string[] | null) => void;
}

export const useStatisticsTariffStore = create<StatisticsTariffState>()(
  (set) => ({
    selectedTariffs: null,
    setSelectedTariffs: (selectedTariffs) => set(() => ({ selectedTariffs })),
  })
);
